import React, {Component, createRef} from "react";
import SelectionButton from "./SelectionButton";
import GemLogin from "../GemLogin";

class GemEmail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      feedback: <div/>, showfeedback: false, emails: [], checkedEmails: new Set(), sortMode: 1, loading: false, token: ''
    };
    this.refInputField = createRef();
  }

  onLogin = (token) => {
    this.setState({token: token});
  }

  onClickGetMailadresses = (e, scope) => {
    if (scope === 'logout') {
      this.setState({token: ''});
    } else {
      this.doFetchAddresses(scope);
    }
  }

  onToggleEmail = (email) => {
    this.setState(prev => {
      const next = new Set(prev.checkedEmails);
      if (next.has(email)) {
        next.delete(email);
      } else {
        next.add(email);
      }
      return {checkedEmails: next};
    });
  }

  onToggleAll = () => {
    this.setState(prev => {
      if (prev.checkedEmails.size === prev.emails.length) {
        return {checkedEmails: new Set()};
      } else {
        return {checkedEmails: new Set(prev.emails.map(e => e.email))};
      }
    });
  }

  onClickSort = () => {
    this.setState(prev => ({sortMode: (prev.sortMode + 1) % 3}));
  }

  getSortedEmails = () => {
    const {emails, sortMode} = this.state;
    if (sortMode === 1) return [...emails].sort((a, b) => a.email.localeCompare(b.email));
    if (sortMode === 2) return [...emails].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    return emails;
  }

  onClickCopy = (e) => {
    const selected = this.state.emails.filter(e => this.state.checkedEmails.has(e.email)).map(e => e.email);
    const text = selected.join(';');
    navigator.clipboard.writeText(text).then(() => {
      this.setState({
        feedback: <div
          id="copyFeedback"
          className="text-xs text-green-400">
          ✔ Mailadressen wurden in die Zwischenablage kopiert
        </div>,
        showfeedback: true
      })

      setTimeout(() => this.setState({feedback: <div/>, showfeedback: false}), 3000);
    });
  }

  doFetchAddresses = async (scope) => {
    if (this.state.token) {
      await this.fetchAddresses(scope);
    } else {
      alert('Bitte einloggen!');
    }
  }

  fetchAddresses = async (scope) => {
    this.setState({loading: true});
    try {
      const response = await fetch(
        "https://api.strapi.peer.kiwi/api/gem-people?filters[gem_scopes][category][$eq]=" + scope +
        "&populate=gem_emails&pagination[page]=1&pagination[pageSize]=999999999", {
          headers: {
            "Content-Type": "application/json", Authorization: "Bearer " + this.state.token,
          },
        });

      if (!response.ok) {
        throw new Error("Fehler beim Laden der E-Mails");
      }
      const result = await response.json();

      const emails = [];
      if (result.data) {
        for (let element of result.data) {
          for (let element2 of element.gem_emails) {
            emails.push({email: element2.email, name: element.name});
          }
        }
      }
      this.setState({
        loading: false, emails: emails, checkedEmails: new Set(emails.map(e => e.email))
      });
    } catch (error) {
      this.setState({
        loading: false, outputText: error.message
      });
    }
  }

  render() {
    let content;
    if (!this.state.token) {
      content = <GemLogin onLogin={this.onLogin}/>;
    } else {
      content = <div className="bg-[#0d1117] min-h-screen flex items-center justify-center text-gray-200 font-mono">
        <div className="w-full max-w-2xl bg-[#161b22] rounded-lg shadow-lg border border-[#30363d] p-6">

          <SelectionButton text='GV' onClick={(e) => this.onClickGetMailadresses(e, 'gv')}/>
          <SelectionButton text='Ausschuss' onClick={(e) => this.onClickGetMailadresses(e, 'ausschuss')}/>
          <SelectionButton text='Bedienungsplan' onClick={(e) => this.onClickGetMailadresses(e, 'bedienungsplan')}/>
          <SelectionButton text='Predigereinteilung' onClick={(e) => this.onClickGetMailadresses(e, 'predigereinteilung')}/>
          <SelectionButton text='Veranstaltungen intern' onClick={(e) => this.onClickGetMailadresses(e, 'veranstaltungen_intern')}/>
          <SelectionButton text='Veranstaltungen extern' onClick={(e) => this.onClickGetMailadresses(e, 'veranstaltungen_extern')}/>
          <SelectionButton text='Gäste' onClick={(e) => this.onClickGetMailadresses(e, 'gaeste')}/>

          <div className="bg-[#010409] border border-[#30363d] rounded p-4 mt-4">
            {this.state.emails.length > 0 && (
              <div className="flex items-center justify-between mb-3 pb-2 border-b border-[#30363d]">
                <div className="flex items-center gap-3">
                  <label className="flex items-center gap-2 text-xs text-gray-400 cursor-pointer select-none">
                    <input
                      type="checkbox"
                      checked={this.state.checkedEmails.size === this.state.emails.length}
                      onChange={this.onToggleAll}
                      className="accent-green-400"
                    />
                    Alle auswählen ({this.state.checkedEmails.size}/{this.state.emails.length})
                  </label>
                  <button
                    className="text-xs px-2 py-1 rounded bg-[#30363d] hover:bg-[#3c444d] text-gray-400 transition"
                    onClick={this.onClickSort}
                    title="Sortierung wechseln"
                  >
                    {this.state.sortMode === 0 && '⇅ unsortiert'}
                    {this.state.sortMode === 1 && '↑ E-Mail'}
                    {this.state.sortMode === 2 && '↑ Name'}
                  </button>
                </div>
                <button
                  className="text-xs px-3 py-1 rounded bg-[#30363d] hover:bg-[#3c444d] text-gray-200 transition"
                  onClick={this.onClickCopy}
                  disabled={this.state.checkedEmails.size === 0}
                >
                  {!this.state.showfeedback && <span>Kopieren ({this.state.checkedEmails.size})</span>}{this.state.feedback}
                </button>
              </div>
            )}
            {this.state.emails.length === 0 ? (
              <div className="text-sm text-gray-500">hier werden die Mail-Adressen ausgegeben</div>
            ) : (
              <div className="flex flex-col gap-1">
                {this.getSortedEmails().map((item, idx) => (
                  <label key={idx} className="flex items-center gap-2 text-sm text-green-400 cursor-pointer hover:text-green-300 select-none">
                    <input
                      type="checkbox"
                      checked={this.state.checkedEmails.has(item.email)}
                      onChange={() => this.onToggleEmail(item.email)}
                      className="accent-green-400"
                    />
                    {item.email}
                    {item.name && <span className="text-gray-500">({item.name})</span>}
                  </label>
                ))}
              </div>
            )}
          </div>

          <SelectionButton text='Abmelden' onClick={(e) => this.onClickGetMailadresses(e, 'logout')} color='bg-red-500 hover:bg-red-600'/>
        </div>
      </div>;
    }
    return content;
  }
}

export default GemEmail;
